import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Crown, User } from "lucide-react";

export const GameSelector = ({ open, onClose, onCreateGame }) => {
  const [playerColor, setPlayerColor] = useState("white");
  const [opponentName, setOpponentName] = useState("Roommate");

  const handleCreate = () => {
    onCreateGame(playerColor, opponentName);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-[#0A0A0A] border-white/10 max-w-md" data-testid="new-game-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-white">New Game</DialogTitle>
          <DialogDescription className="text-white/50">
            Start a new chess game with AI analysis
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 mt-4">
          {/* Color Selection */}
          <div className="space-y-3">
            <Label className="text-white/70 text-sm">Choose Your Color</Label>
            <div className="grid grid-cols-2 gap-3">
              <button
                onClick={() => setPlayerColor("white")}
                className={`p-4 rounded-md border transition-all ${
                  playerColor === "white"
                    ? "bg-white/10 border-[#D4AF37] shadow-[0_0_15px_rgba(212,175,55,0.2)]"
                    : "bg-transparent border-white/10 hover:border-white/20"
                }`}
                data-testid="select-white-btn"
              >
                <div className="flex flex-col items-center gap-2">
                  <div className="w-12 h-12 rounded-full bg-[#E2E2E2] flex items-center justify-center">
                    <Crown className="text-[#262626]" size={24} />
                  </div>
                  <span className={`text-sm font-medium ${
                    playerColor === "white" ? "text-white" : "text-white/60"
                  }`}>
                    White
                  </span>
                  <span className="text-xs text-white/40">Moves first</span>
                </div>
              </button>
              
              <button
                onClick={() => setPlayerColor("black")}
                className={`p-4 rounded-md border transition-all ${
                  playerColor === "black"
                    ? "bg-white/10 border-[#D4AF37] shadow-[0_0_15px_rgba(212,175,55,0.2)]"
                    : "bg-transparent border-white/10 hover:border-white/20"
                }`}
                data-testid="select-black-btn"
              >
                <div className="flex flex-col items-center gap-2">
                  <div className="w-12 h-12 rounded-full bg-[#262626] flex items-center justify-center border border-white/20">
                    <Crown className="text-[#E2E2E2]" size={24} />
                  </div>
                  <span className={`text-sm font-medium ${
                    playerColor === "black" ? "text-white" : "text-white/60"
                  }`}>
                    Black
                  </span>
                  <span className="text-xs text-white/40">Moves second</span>
                </div>
              </button>
            </div>
          </div>

          {/* Opponent Name */}
          <div className="space-y-2">
            <Label className="text-white/70 text-sm flex items-center gap-2">
              <User size={14} />
              Opponent Name
            </Label>
            <Input
              type="text"
              value={opponentName}
              onChange={(e) => setOpponentName(e.target.value)}
              placeholder="Roommate"
              className="bg-transparent border-white/20 text-white"
              data-testid="opponent-name-input"
            />
          </div>

          {/* Create Button */}
          <Button
            onClick={handleCreate}
            className="w-full bg-[#D4AF37] text-black hover:bg-[#E5C158] btn-gold-glow font-medium"
            data-testid="create-game-btn"
          >
            Start Game
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
